import React, { useState } from 'react';
import classnames from 'classnames';
import { Stack } from '../../components/Stack/Stack';
import Logo from './scanner-logo.svg';
import { Container } from '../../components/Container/Container';
import { Icon } from '../../components/Icon/Icon';
import './lobby.css';
import { deviceBarcodeReader, DeviceBarcodeReader } from './DeviceBarcodeReader';
import { history } from '../../model/history';
import { t } from '../../locales/translate';
import { QRReader } from './QRReader';

type LobbyState = 'loading' | 'ready' | 'scanning';

export function Lobby(): JSX.Element {
  const [notALinkError, setNotALinkError] = useState(false);
  const [state, setState] = useState<LobbyState>('loading');

  function parseCode(code: string): void {
    try {
      const url = new URL(code);
      const path = code.replace(url.origin, '');
      if (path.includes('/ticket-scanner')) {
        setNotALinkError(false);
        history.push(path);
        deviceBarcodeReader.beep('success');
      } else {
        deviceBarcodeReader.beep('fail');
        setNotALinkError(true);
      }
    } catch {
      deviceBarcodeReader.beep('fail');
      setNotALinkError(true);
    }
  }

  return (
    <Container isMobile className="ticket-scanner lobby">
      <Stack size="xl" className="lobby__content">
        <div className="lobby__logo">
          <img src={Logo} />
        </div>
        <Stack size="xs">
          <div className={classnames('lobby__scanner')}>
            <QRReader
              codeTypes={['qr']}
              isScanning={state === 'scanning'}
              displayVideo={state === 'scanning'}
              onVideoInitialized={() => setState('scanning')}
              onScanCode={parseCode}
            />
            {state !== 'scanning' && (
              <div className="lobby__scanner-placeholder">
                <Icon name="camera-off" />
              </div>
            )}
          </div>
        </Stack>
        <Stack size="xs" className="lobby__qr-icon">
          <Icon name="qr" />
          <div className="lobby__prompt">
            {notALinkError ? t.page.ticketScanner.invalidEventCode : t.page.ticketScanner.scanCodeToGetStarted}
          </div>
        </Stack>
        <div className="lobby__contact">
          <a href="mailto:ticketing@krasserstoff.com">{t.page.ticketScanner.contactUs}</a>
        </div>
      </Stack>
      <DeviceBarcodeReader onScanCode={parseCode} />
    </Container>
  );
}
